import { useMutation } from '@tanstack/react-query';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { parseError } from '@/utils/axios';

import { logosQueryKeys } from './query-keys';

export type TDeleteLogosParams = {
  id: string;
};

export function deleteLogos({ id }: TDeleteLogosParams): Promise<unknown> {
  return mediaManagerClient.delete(`/api/v1/logos/${id}`);
}

type MutationFn = typeof deleteLogos;

type UseDeleteLogosParams = {
  config?: MutationConfig<MutationFn>;
};

export function useDeleteLogos({ config }: UseDeleteLogosParams = {}) {
  const { addErrorNotification, addSuccessNotification } = useNotificationStore();

  return useMutation({
    onError(error) {
      const { status } = parseError(error);
      console.error(error);

      if (status === 404) {
        return addErrorNotification('El logo no existe');
      }
      addErrorNotification('No se ha podido eliminar el logo');
    },
    onSuccess() {
      queryClient.invalidateQueries({ queryKey: logosQueryKeys.all });
      addSuccessNotification('El logo se ha eliminado correctamente');
    },
    ...config,
    mutationFn: deleteLogos,
  });
}
